document.addEventListener("DOMContentLoaded", () => {
  const swipers = document.querySelectorAll('.lis-swiper');

  swipers.forEach(container => {
    let autoplaySpeed = parseInt(container.dataset.speed, 10);
    
    if (isNaN(autoplaySpeed) || autoplaySpeed <= 0) {
      autoplaySpeed = 3000;
    }

    new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      loop: true,
      centeredSlides: true,
    //   autoplay: {
    //     delay: autoplaySpeed,
    //     disableOnInteraction: false
    //   },
    });
  });
});